import React, { useMemo, useState } from 'react';
import { AlertTriangle, CheckCircle2, Trash2 } from 'lucide-react';
import { useAppStore } from '../../../../app/hooks/useAppStore';
import { detectOrphanedClassrooms, cleanupOrphans } from '../../../../accounts';
import { Button } from '../../../../components/ui/Button';
import { Card } from '../../../../components/ui/Card';
import { ConfirmDialog } from '../../../../components/shared/ConfirmDialog';
export function OrphanStatus() {
  const {
    accounts,
    setAccountsState
  } = useAppStore();
  const [isCleaning, setIsCleaning] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const report = useMemo(() => detectOrphanedClassrooms(accounts), [accounts]);
  const handleCleanup = () => {
    setIsCleaning(true);
    setTimeout(() => {
      const nextState = cleanupOrphans(accounts, report);
      setAccountsState(nextState);
      setIsCleaning(false);
      setShowConfirm(false);
    }, 500);
  };
  if (report.totalIssues === 0) {
    return <Card className="p-8 text-center border-emerald-200 bg-emerald-50/50" data-id="element-8263" data-mp="2cqpkw9y347v">
        <div className="flex justify-center mb-4" data-id="element-8264" data-mp="3uhktuvzf2jep">
          <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600" data-id="element-8265" data-mp="3uj47eetougcs">
            <CheckCircle2 className="w-6 h-6" data-id="element-8266" data-mp="c9lm59mnquji" />
          </div>
        </div>
        <h3 className="text-lg font-bold text-emerald-900 mb-2" data-id="element-8267" data-mp="7b0kd5rrc2sy">
          Geen wees-records gevonden
        </h3>
        <p className="text-emerald-700 text-sm" data-id="element-8268" data-mp="la9z010beout">
          De database is gezond. Alle klassen hebben een eigenaar en alle
          gekoppelde co-docenten en leerlingen bestaan.
        </p>
      </Card>;
  }
  return <div className="space-y-6" data-id="element-8269" data-mp="v40i0qdoa734">
      <Card className="p-6 border-amber-200 bg-amber-50/50" data-id="element-8270" data-mp="q2l0v9em8kq0">
        <div className="flex items-start justify-between" data-id="element-8271" data-mp="q5fhsqyf7neo">
          <div className="flex items-start gap-4" data-id="element-8272" data-mp="15157p06q8koo">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center text-amber-600 flex-shrink-0 mt-1" data-id="element-8273" data-mp="10195n6hlb3br">
              <AlertTriangle className="w-5 h-5" data-id="element-8274" data-mp="175ic7veot7wc" />
            </div>
            <div data-id="element-8275" data-mp="1c3jx8lvobhag">
              <h3 className="text-lg font-bold text-amber-900 mb-1" data-id="element-8276" data-mp="1c30kdjkvrj3a">
                {report.totalIssues} wees-records gevonden
              </h3>
              <p className="text-amber-700 text-sm mb-4" data-id="element-8277" data-mp="1h1by45eaqdqs">
                Er zijn klassen of koppelingen gevonden waarvan het bijbehorende
                account niet meer bestaat. Dit kan gebeuren bij hard-deletes of
                inconsistente migraties.
              </p>
              <ul className="space-y-2 text-sm text-amber-800" data-id="element-8278" data-mp="1usqes5kqe2uo">
                {report.orphanedClassrooms.length > 0 && <li data-id="element-8279" data-mp="1ztnywnpax6yt">
                    <span className="font-bold" data-id="element-8280" data-mp="1zr1u2vtsp5ka">
                      {report.orphanedClassrooms.length}
                    </span>{' '}
                    klassen zonder eigenaar
                  </li>}
                {report.orphanedCoTeachers.length > 0 && <li data-id="element-8281" data-mp="aderywuec62x">
                    <span className="font-bold" data-id="element-8282" data-mp="aezout46o13y">
                      {report.orphanedCoTeachers.length}
                    </span>{' '}
                    ontbrekende co-docenten
                  </li>}
                {report.orphanedLearners.length > 0 && <li data-id="element-8283" data-mp="3pa9pkkdmcvfk">
                    <span className="font-bold" data-id="element-8284" data-mp="3p9qk4355nzif">
                      {report.orphanedLearners.length}
                    </span>{' '}
                    ontbrekende leerlingen in klassen
                  </li>}
              </ul>
            </div>
          </div>
          <Button onClick={() => setShowConfirm(true)} className="bg-amber-600 hover:bg-amber-700 text-white" data-id="element-8285" data-mp="lrgov85xw12t">
            
            <Trash2 className="w-4 h-4 mr-2" data-id="element-8286" data-mp="bv3oxsjswqzm" />
            Opschonen
          </Button>
        </div>
      </Card>

      <ConfirmDialog open={showConfirm} title="Wees-records opschonen" message={`Weet je zeker dat je ${report.totalIssues} wees-records wilt verwijderen? Klassen zonder eigenaar worden volledig verwijderd. Ontbrekende co-docenten en leerlingen worden uit hun klassen gehaald.`} confirmLabel={isCleaning ? 'Bezig...' : 'Ja, schoon op'} cancelLabel="Annuleren" variant="danger" onConfirm={handleCleanup} onCancel={() => setShowConfirm(false)} data-id="element-8287" data-mp="6wsgnm95moji" />
      
    </div>;
}